/**
 * Ported from `apps/mobile/src/ui/StandingsTableLogic.ts`. `secondaryLine` is
 * not ported: on web the secondary columns are real table columns, not a
 * second text line under the row.
 */
import {
  STANDINGS_MISSING_CELL,
  type typeStandingsColumn,
} from "./standingsTypes";

/** The display string for one cell. A key with no value renders a placeholder hyphen. */
export function cellText(values: Record<string, string>, key: string): string {
  return values[key] ?? STANDINGS_MISSING_CELL;
}

/** "1 Cascades, W 10, L 2, T 0, PCT .833" */
export function rowAccessibilityLabel(input: {
  rankLabel: string;
  teamName: string;
  columns: typeStandingsColumn[];
  values: Record<string, string>;
}): string {
  if (input.columns.length === 0) {
    return `${input.rankLabel} ${input.teamName}`;
  }
  const pairs = input.columns.map(
    (column) => `${column.label} ${cellText(input.values, column.key)}`,
  );
  return `${input.rankLabel} ${input.teamName}, ${pairs.join(", ")}`;
}
